export function CalendarIcon(
  props: React.SVGProps<SVGSVGElement> & { color: string },
) {
  const { color, ...rest } = props;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Calendar</title>
      <g clipPath="url(#clip0_25_598)">
        <path
          d="M19 2H18V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0C16.7348 0 16.4804 0.105357 16.2929 0.292893C16.1054 0.48043 16 0.734784 16 1V2H8V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0C6.73478 0 6.48043 0.105357 6.29289 0.292893C6.10536 0.48043 6 0.734784 6 1V2H5C3.6744 2.00159 2.40356 2.52888 1.46622 3.46622C0.528882 4.40356 0.00158786 5.6744 0 7L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.6744 23.9984 5 24H19C20.3256 23.9984 21.5964 23.4711 22.5338 22.5338C23.4711 21.5964 23.9984 20.3256 24 19V7C23.9984 5.6744 23.4711 4.40356 22.5338 3.46622C21.5964 2.52888 20.3256 2.00159 19 2V2ZM2 7C2 6.20435 2.31607 5.44129 2.87868 4.87868C3.44129 4.31607 4.20435 4 5 4H19C19.7956 4 20.5587 4.31607 21.1213 4.87868C21.6839 5.44129 22 6.20435 22 7V8H2V7ZM19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V10H22V19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22Z"
          fill={color}
        />
        <path
          d="M12 16.5C12.8284 16.5 13.5 15.8284 13.5 15C13.5 14.1716 12.8284 13.5 12 13.5C11.1716 13.5 10.5 14.1716 10.5 15C10.5 15.8284 11.1716 16.5 12 16.5Z"
          fill={color}
        />
        <path
          d="M6.99985 16.5C7.82827 16.5 8.49985 15.8284 8.49985 15C8.49985 14.1716 7.82827 13.5 6.99985 13.5C6.17142 13.5 5.49985 14.1716 5.49985 15C5.49985 15.8284 6.17142 16.5 6.99985 16.5Z"
          fill={color}
        />
        <path
          d="M17.0002 16.5C17.8286 16.5 18.5002 15.8284 18.5002 15C18.5002 14.1716 17.8286 13.5 17.0002 13.5C16.1717 13.5 15.5002 14.1716 15.5002 15C15.5002 15.8284 16.1717 16.5 17.0002 16.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_25_598">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
